import CustomButton from "../../../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { fetchUsers, postDeleteUser } from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { removeUserFromUsers } from "../../../../../redux/reducer/admin.reducer";
import { adminRoutes } from "../../../../../router/routesConstants";

function UsersActionButton({ itemId, crudData, tableContext }: any) {
  const dispatch = useAppDispatch();

  const handleDeleteOrActivateUser = async () => {
    const resultAction = await dispatch(postDeleteUser(itemId));

    if (
      checkEndpointStatus(resultAction, postDeleteUser) ===
      endpointStatus.fulfilled
    ) {
      if (
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage &&
        tableContext.tableSearch
      ) {
        dispatch(removeUserFromUsers(itemId));

        dispatch(
          fetchUsers({
            page: tableContext.tablePagination.page,
            perPage: tableContext.tablePagination.rowsPerPage,
            username: tableContext.tableSearch.username,
            firstName: tableContext.tableSearch.firstName,
            lastName: tableContext.tableSearch.lastName,
          }),
        );
      }
    }
  };

  return (
    <div>
      {crudData.deleted === 0 && (
        <>
          <CustomButton
            variant="contained"
            tooltipTitle="Editeaza utilizator"
            className="mt-1 me-1"
            navigate={`/${adminRoutes.users}/${adminRoutes.editUser}?userId=${itemId}`}>
            <SvgIcon type="EDIT" />
          </CustomButton>

          <CustomButton
            variant="contained"
            tooltipTitle="Roluri web"
            className="mt-1 me-1"
            navigate={`/${adminRoutes.users}/${adminRoutes.adminUserWebRoles}?userId=${itemId}&userName=${crudData.userName}`}>
            <SvgIcon type="WEB_ROLES" fill="white" className="svg-icon-2" />
          </CustomButton>
          <CustomButton
            variant="contained"
            tooltipTitle="Roluri palm"
            className="mt-1 me-1"
            navigate={`/${adminRoutes.users}/${adminRoutes.adminUserMobileRoles}?userId=${itemId}&userName=${crudData.userName}`}>
            <SvgIcon type="PALM_ROLES" fill="white" className="svg-icon-2" />
          </CustomButton>
        </>
      )}
      {crudData.deleted === 0 ? (
        <CustomButton
          variant="contained"
          tooltipTitle="Stergere"
          color="error"
          className="mt-1 me-1"
          withConfirmationModal={{
            modalTitle: "Stergere utilizator",
            modalSubtitle: `Doriti sa stergeti utilizatorul: ${crudData.userName}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDeleteOrActivateUser,
          }}>
          <SvgIcon type="DELETE" />
        </CustomButton>
      ) : (
        <CustomButton
          variant="contained"
          tooltipTitle="Activeaza"
          color="success"
          className="mt-1 me-1"
          withConfirmationModal={{
            modalTitle: "Activare utilizator",
            modalSubtitle: `Doriti sa activati utilizatorul: ${crudData.userName}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDeleteOrActivateUser,
          }}>
          <SvgIcon type="ACTIVATE" fill="white" />
        </CustomButton>
      )}
    </div>
  );
}

export default UsersActionButton;
